import { render, staticRenderFns } from "./index04.vue?vue&type=template&id=428dc70f&scoped=true&"
import script from "./index04.vue?vue&type=script&lang=js&"
export * from "./index04.vue?vue&type=script&lang=js&"
import style0 from "./index04.vue?vue&type=style&index=0&id=428dc70f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428dc70f",
  null
  
)

export default component.exports